import { isJapaneseLocale, getLocaleCode } from '../../../utils/locale'

export const stripText = (text) => text.replace(/[()]/g, ' ').replace(/\s+/g, ' ')
  .replace(/\s+/g, isJapaneseLocale() ? '' : ' ').trim()
  .toLocaleLowerCase(getLocaleCode())

export const filterByTextAndGroupByTagAndVersion = (items, text, itemCategory, accumulator) => items
  .filter((x) => stripText(x.item.title).includes(text) || stripText(x.tag.name).includes(text))
  .reduce((acc, { tag, item }) => {
    if (!acc[tag.key]) {
      acc[tag.key] = {
        tag: {
          key: tag.key,
          name: tag.name,
        },
        endpoints: {},
        resources: {},
        versions: {},
      }
    }
    if (!acc[tag.key][itemCategory][item.version]) {
      acc[tag.key][itemCategory][item.version] = []
      acc[tag.key].versions[item.version] = { deprecated: tag.deprecated }
    }
    acc[tag.key][itemCategory][item.version].push(item)
    return acc
  }, accumulator)

export const isResourcePath = (pathname) => pathname
  .split("/").filter((e) => e.length > 0).slice(1)
  .some((e) => e === 'resources')

export const isTagNotEmpty = (tag) => tag.resources?.[0] || tag.endpoints?.[0]
